import React from 'react';
import { XIcon } from 'lucide-react';
const pains = ["Planning next week's class on your one free evening — unpaid", 'Staring at a blank page with no idea where to start the choreography', 'Needing "just one or two more series" to finish the class', 'Teaching the same three sequences because there is no time to write new ones', 'Fitting class prep around a full-time job or two other gigs', 'A mixed-level room and no plan for the first-timer in the back row', 'Counting out a new block in the car on the way to the studio', 'Less and less time to take a class yourself'];
export function PainGrid() {
  return <section aria-labelledby="pain-heading" className="w-full bg-plum" data-id="element-168" data-mp="1bqcqfo1opctt">
      <div className="max-w-5xl mx-auto px-5 py-16 sm:py-20" data-id="element-169" data-mp="17p0vr43ye1er">
        <div className="text-center" data-id="element-170" data-mp="363vjoloom99b">
          <p className="text-[11px] font-semibold uppercase tracking-[1.8px] text-gold" data-id="element-171" data-mp="362u7uezudiqj">
            The part nobody pays you for
          </p>
          <h2 id="pain-heading" className="mt-3 font-display font-semibold text-white text-3xl sm:text-4xl md:text-5xl leading-tight" data-id="element-172" data-mp="3205w9zjqtxpv">
            If you teach barre, you know at least{' '}
            <span className="italic text-coral-soft" data-id="element-173" data-mp="378op522zq5md">half of this list.</span>
          </h2>
        </div>

        <ul className="mt-9 grid gap-3 text-left sm:grid-cols-2 sm:gap-x-5" data-id="element-174" data-mp="3b9gx7s04m4h2">
          {pains.map(pain => <li key={pain} className="flex items-start gap-3 rounded-2xl border border-plum-line bg-plum-card px-4 py-4 text-sm text-white/85" data-id="element-175" data-mp="2tx9f8i85e9e">
              <span className="mt-0.5 flex h-5 w-5 flex-none items-center justify-center rounded-full bg-coral/20" data-id="element-176" data-mp="3q7stvyni1d88">
                <XIcon className="h-3 w-3 text-coral-soft" aria-hidden="true" data-id="element-177" data-mp="3u7t7xi6ormer" />
              </span>
              {pain}
            </li>)}
        </ul>

        <p className="mt-10 text-center font-display italic text-2xl sm:text-3xl text-gold leading-tight" data-id="element-178" data-mp="qkktes5ezucb">
          How many more Sunday nights do you want to spend planning?
        </p>
      </div>
    </section>;
}